import React from 'react';
import PropTypes from 'prop-types';

export const RadioCheckList = ({ children, className = '' }) => {
  return <div className={className}>{children}</div>;
};

RadioCheckList.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
};
